import React, { useEffect, useState } from 'react';
import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemIcon,
    ListItemText,
    Modal,
    TextField,
    MenuItem,
    Divider,
    IconButton,
    Button,
    TextareaAutosize,
    Select,
    FormControl,
    InputLabel,
    CircularProgress,
    Grid
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import MaleIcon from '@mui/icons-material/Male';
import EditIcon from '@mui/icons-material/Edit';
import WorkIcon from '@mui/icons-material/Work';
import AssignmentIcon from '@mui/icons-material/Assignment';
import './styles.css';
import CloseIcon from '@mui/icons-material/Close'
import { UpdateUserDetailsCommand, UserCategoryViewModel, UserDetailsViewModel } from '../../../../configuration/api/apiSchema';
import BusinessLocationMap from './BusinessLocationMap';
import BusinessLocationAutocomplete from './BusinessLocationAutocomplete';
import { connect } from 'react-redux';
import { HandymanAppState } from '../../../../configuration/redux/reducers';
import { getUserCategories } from '../../../Categories/actions';
import { openStripeOnboardingLink } from '../../../Categories/actions';
import { AuthData } from '../../../Auth/reducer';
import { getCurrentUserDetails, getUserDetails, updateUserDetails } from '../../../Auth/actions';
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import { Link } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch'; // Put this near your imports
import ChatIcon from '@mui/icons-material/Chat';                
import { useDispatch } from 'react-redux';                     
import { useNavigate } from 'react-router-dom';                   
import { createOrGetChat, withdrawBalance } from '../../../Orders/actions';
import { useAppDispatch } from '../../../../configuration/redux/hooks';
import { startUserKyc } from '../../../Categories/actions';
import Feed from '@mui/icons-material/Feed';

interface StateFromProps {
    isCategoriesLoading: boolean;
    isDetailsUpdated: boolean;
    userCategories?: UserCategoryViewModel[];
    authData?: AuthData;
    userDetails?: UserDetailsViewModel;
    currentUser?: UserDetailsViewModel;
    isUserLoading: boolean;
}

interface DispatchFromProps {
    getUserCategories: (userId?: string) => void;
    getUserDetails: (userId?: string) => void;
    updateUserDetails: (command: UpdateUserDetailsCommand) => void;
}

interface PassedProps {
    userId?: string;
}

const UserDetails = (props: PassedProps & DispatchFromProps & StateFromProps) => {
    const isReadonly = props.userId !== undefined;
    const isSignedIn = props.authData !== undefined;

        // [5] NEW: get dispatch & navigate
        const dispatch = useAppDispatch();
        const navigate = useNavigate();
        const currentUserId = props.currentUser?.id;
    
        // [6] NEW: helper to open chat
        const handleOpenChat = async () => {
          if (!currentUserId || !props.userId) return;
          try {
            const chatId = await dispatch(createOrGetChat([currentUserId, props.userId]) as any);
            if (chatId) {
              navigate(`/chats/${chatId}`);
            }
          } catch (error) {
            console.error('Failed to open or create chat:', error);
          }
        };

    const [kycBusy, setKycBusy] = useState(false);
    const [open, setOpen] = useState(false);
    const [modalType, setModalType] = useState('contact');
    const [formValues, setFormValues] = useState({
        email: 'handy.man2024@outlook.com',
        location: 'Odessa',
        firstName: '',
        lastName: "",
        birthDate: '1980-02-12',
        gender: 'Male',
        bio: 'Experienced .NET and React developer.',
        categories: [] as string[],
        orders: ['Website Development 0/10', 'Website Fixes 0/10', 'Website Layout 0/10'],
        businessLocation: '',
        serviceAreaAddress: ''
    });
    const balance = props.userDetails?.balance ?? 0;
    const balanceInTransfer = props.userDetails?.balanceInTransfer ?? 0;
    const canWithdraw = balance > 0; 
    const [isWithdrawModalOpen, setWithdrawModalOpen] = useState(false);
    const [withdrawAmount, setWithdrawAmount] = useState("");
    const [withdrawError, setWithdrawError] = useState(""); 

    useEffect(() => {
        if (props.authData) {
            if (props.userId) {
                props.getUserCategories(props.userId)
            }
            else {
                props.getUserCategories()
            }
        }
    }, [props.authData])

    useEffect(() => {
        if (props.userCategories) {
            setFormValues({
                ...formValues,
                categories: props.userCategories.map(x => x.name as string)
            })
        }
    }, [props.userCategories, props.isCategoriesLoading])

    useEffect(() => {
        if (props.userDetails) {
          setFormValues((prev) => {
            const hasUserSelectedBusinessLocation =
              prev.businessLocation && prev.businessLocation !== props.userDetails?.serviceAreaAddress;
      
            return {
              ...prev,
              firstName: props.userDetails?.firstName ?? prev.firstName,
              lastName: props.userDetails?.lastName ?? prev.lastName,
              email: props.userDetails?.email ?? prev.email,
              birthDate: props.userDetails?.birthDate ?? prev.birthDate,
              gender: props.userDetails?.gender ?? prev.gender,
              location: props.userDetails?.location ?? prev.location,
              bio: props.userDetails?.bio ?? prev.bio,
              categories: prev.categories,
              serviceAreaAddress: props.userDetails?.serviceAreaAddress ?? prev.serviceAreaAddress,
              businessLocation: hasUserSelectedBusinessLocation
                ? formValues.businessLocation
                : props.userDetails?.serviceAreaAddress ?? prev.businessLocation,
            };
          });
        }
      }, [props.userDetails, props.isCategoriesLoading]);
      
    useEffect(() => {
        if (props.isDetailsUpdated) {
            if (props.userId) {
                props.getUserDetails(props.userId);
            }
            else {
                props.getUserDetails();
            }

            handleClose();
        }
    }, [props.isDetailsUpdated])

    const handleKycClick = async () => {
  try {
    setKycBusy(true);
    const res = await dispatch(startUserKyc() as any);

    if (!res) return;                // 👉 nothing to do on 404

    window.open(res.shareableUrl!, "_blank", "noopener,noreferrer");
  } finally {
    setKycBusy(false);
  }
};

    const rootCategories = ['AI Services', 'Digital Marketing', 'Home Services', 'Appliance Repair', 'Cleaning Services'];

    const handleOpen = (type: string) => {
        setModalType(type);
        setOpen(true);
    };

    const handleClose = () => setOpen(false);

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement | { name?: string; value: unknown }>) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name!]: value }));
    };

    const handleTextareaChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        const { name, value } = e.target;
        setFormValues((prev) => ({ ...prev, [name]: value }));
    };

    const handleCategoriesChange = (event: React.ChangeEvent<{ value: unknown }>) => {
        setFormValues((prev) => ({ ...prev, categories: event.target.value as string[] }));
    };

    const handleSubmit = () => {
        props.updateUserDetails({
            email: formValues.email,
            birthDate: formValues.birthDate,
            firstName: formValues.firstName,
            lastName: formValues.lastName,
            bio: formValues.bio,
            gender: formValues.gender,
            location: formValues.location,
            serviceArea: formValues.businessLocation ? formValues.businessLocation : formValues.serviceAreaAddress,
        } as UpdateUserDetailsCommand)
    };

   const handleConfirmWithdraw = () => {
    const numericAmount = parseFloat(withdrawAmount);
    const max = props.userDetails?.balance ?? 0;

    if (isNaN(numericAmount) || numericAmount <= 0) {
        setWithdrawError("Amount must be greater than 0.");
        return;
    }

    if (numericAmount > max) {
        setWithdrawError(`Amount cannot exceed your balance (${max.toFixed(2)} GBP).`);
        return;
    }

    setWithdrawError("");
    dispatch(withdrawBalance(numericAmount));
    setWithdrawModalOpen(false);
    setWithdrawAmount("");
    };

    return (
        <>
            <Typography variant="h6" gutterBottom>Contact Info</Typography>
            <Grid container spacing={4}>
                {/* Left Column */}
                <Grid item xs={12} md={6}>
                    <List>
                        <ListItem sx={{ position: 'relative' }}>
                            <ListItemIcon>
                                <DriveFileRenameOutlineIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>First Name:</b>}
                                secondary={formValues.firstName}
                            />
                        </ListItem>
                        <ListItem sx={{ position: 'relative' }}>
                            <ListItemIcon>
                                <DriveFileRenameOutlineIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>Last Name:</b>}
                                secondary={formValues.lastName}
                            />
                        </ListItem>
                        <ListItem sx={{ position: 'relative' }}>
                            <ListItemIcon>
                                <LocationOnIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>Location:</b>}
                                secondary={formValues.location}
                            />
                        </ListItem>
                        {props.userDetails?.roleId === '6a4691e0-dab2-469c-943a-c26809c6c8ec' &&
                        formValues.serviceAreaAddress && (
                        <ListItem>
                            <ListItemIcon>
                            <LocationOnIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                            primary={<b>Business Location:</b>}
                            secondary={formValues.serviceAreaAddress}
                            />
                        </ListItem>
                        )}
                        {props.userDetails?.roleId === '6a4691e0-dab2-469c-943a-c26809c6c8ec' && (
                        <>
                            <ListItem
                            // secondaryAction={
                            //     canWithdraw && (          // ✅ render only when balance > 0
                            //     <Button
                            //         variant="contained"
                            //         size="small"
                            //         onClick={() => setWithdrawModalOpen(true)}
                            //     >
                            //         Withdraw
                            //     </Button>
                            //     )
                            // }
                            >
                            <ListItemIcon>
                                <AssignmentIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>Balance:</b>}
                                secondary={`${balance.toFixed(2)} GBP`}
                            />
                            </ListItem>
                            
                            <ListItem>
                            <ListItemIcon>
                                <AssignmentIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>In transfer:</b>}
                                secondary={`${balanceInTransfer.toFixed(2)} GBP`}
                            />
                            </ListItem>

                            <ListItem>
                            <ListItemIcon>
                                <AssignmentIcon className="info-item-icon" />
                            </ListItemIcon>

                            <ListItemText
                                primary={<b>Stripe verification status:</b>}
                                secondary={
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                    <span style={{ color: props.userDetails?.isStripeAccountVerified ? 'green' : 'red', fontWeight: 600 }}>
                                    {props.userDetails?.isStripeAccountVerified ? 'Verified' : 'Not Verified'}
                                    </span>
                                    <Button
                                    variant="outlined"
                                    size="small"
                                    endIcon={<LaunchIcon />}
                                    onClick={() => dispatch(openStripeOnboardingLink())}
                                    >
                                    {props.userDetails?.isStripeAccountVerified
                                        ? 'Check status'
                                        : 'Verify account'}
                                    </Button>
                                </Box>
                                }
                            />
                            </ListItem>
                        </>
                        )}
                    </List>
                </Grid>

                {/* Right Column */}
                <Grid item xs={12} md={6}>
                    <List>
                        <ListItem sx={{ position: 'relative' }}>
                            <ListItemIcon>
                                <EmailIcon className="info-item-icon" />
                            </ListItemIcon>
                            {
                                isSignedIn ? <ListItemText
                                    primary={<b>Email:</b>}
                                    secondary={formValues.email}
                                />
                                    : <ListItemText
                                        primary={<b>Email:</b>}
                                        secondary={<><Link to={"/sign-in"}>Sign in</Link>  to view contacts</>}
                                    />
                            }

                        </ListItem>
                        <ListItem sx={{ position: 'relative' }}>
                            <ListItemIcon>
                                <CalendarTodayIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>Birth Date:</b>}
                                secondary={formValues.birthDate}
                            />
                        </ListItem>
                        <ListItem sx={{ position: 'relative' }}>
                            <ListItemIcon>
                                <MaleIcon className="info-item-icon" />
                            </ListItemIcon>
                            <ListItemText
                                primary={<b>Gender:</b>}
                                secondary={formValues.gender}
                            />
                        </ListItem>

                        <ListItem sx={{ position: 'relative' }}>
                        <ListItemIcon>
                            <Feed className="info-item-icon" />
                        </ListItemIcon>

                        <ListItemText
                            primary={<b>KYC verification status:</b>}
                            secondary={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                                {/* status label */}
                                <span style={{
                                color:
                                    props.userDetails?.kycStatus === 'Verified'
                                    ? 'green'
                                    : props.userDetails?.kycStatus === 'Pending'
                                        ? 'orange'
                                        : props.userDetails?.kycStatus === 'Review'
                                        ? 'orange'
                                        : 'red',
                                fontWeight: 600,
                                }}>
                                {(() => {
                                    switch (props.userDetails?.kycStatus) {
                                    case 'Pending':  return 'Pending';
                                    case 'Verified': return 'Verified';
                                    case 'Failed':   return 'Failed';
                                    case 'Review':   return 'Marked for manual review';
                                    default:         return 'Not verified';
                                    }
                                })()}
                                </span>

                                {/* action button – render only when applicable */}
                                {['NotStarted', 'Pending', 'Failed'].includes(props.userDetails?.kycStatus ?? 'NotStarted') && (
                                <Button
                                    variant="outlined"
                                    size="small"
                                    endIcon={<LaunchIcon />}
                                    onClick={handleKycClick}
                                    disabled={kycBusy}
                                >
                                    {kycBusy
                                    ? <CircularProgress size={16} />
                                    : props.userDetails?.kycStatus === 'Pending'
                                        ? 'Continue'
                                        : props.userDetails?.kycStatus === 'Failed'
                                        ? 'Retry'
                                        : 'Verify'}
                                </Button>
                                )}
                            </Box>
                            }
                        />
                        </ListItem>
                        {isSignedIn && currentUserId && props.userId && currentUserId !== props.userId && (
                          <Button
                            onClick={handleOpenChat}
                            variant="text"
                            startIcon={<ChatIcon />}
                            size="small"
                            sx={{
                              position: 'absolute',
                              top: 8,
                              right: 16,
                              color: 'primary.main',
                              textDecoration: 'underline',
                              '&:hover': {
                                textDecoration: 'underline',
                              },
                            }}
                          >
                            Message
                          </Button>
                        )}
                        {
                            !isReadonly && <IconButton
                                onClick={() => handleOpen('contact')}
                                size="small"
                                sx={{ position: 'absolute', top: 8, right: 16 }}
                            >
                                <EditIcon />
                            </IconButton>
                        }

                    </List>
                </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />
            <Box sx={{ position: 'relative' }}>
                <Typography variant="h6" gutterBottom>About Me</Typography>
                <ListItemText secondary={formValues.bio} />
                {
                    !isReadonly && <IconButton onClick={() => handleOpen('bio')} size="small" sx={{ position: 'absolute', top: 8, right: 16 }}>
                        <EditIcon />
                    </IconButton>
                }

            </Box>

            <Divider sx={{ my: 2 }} />
            <Box sx={{ position: 'relative' }}>
                <Typography variant="h6" gutterBottom>Order Categories</Typography>
                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                    {formValues.categories.map((category, index) => (
                        <Box key={index} sx={{ display: 'flex', alignItems: 'center', gap: 1, border: '1px solid #ccc', borderRadius: '8px', padding: '4px 8px' }}>
                            <WorkIcon fontSize="small" />
                            <Typography variant="body2">{category}</Typography>
                        </Box>
                    ))}
                </Box>
                {
                    !isReadonly && <IconButton onClick={() => handleOpen('categories')} size="small" sx={{ position: 'absolute', top: 8, right: 16 }}>
                        <EditIcon />
                    </IconButton>
                }
            </Box>

            <Divider sx={{ my: 2 }} />
            <Typography variant="h6" gutterBottom>Orders</Typography>
            <Box>
                {formValues.orders.map((order, index) => (
                    <ListItem key={index}>
                        <ListItemIcon><AssignmentIcon className='info-item-icon' /></ListItemIcon>
                        <ListItemText primary={order} />
                    </ListItem>
                ))}
            </Box>

            <Modal 
                open={open} onClose={handleClose} 
                aria-labelledby="edit-user-details">
                <Box
                    sx={{
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: 400,
                        maxHeight: '80vh',
                        overflowY: 'auto',
                        bgcolor: 'background.paper',
                        borderRadius: 2,
                        boxShadow: 24,
                        p: 4
                    }}
                >
                    {/* Close Icon */}
                    <IconButton
                        size="small"
                        onClick={handleClose}
                        sx={{ position: 'absolute', top: 8, right: 8 }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Typography id="edit-user-details" variant="h6" gutterBottom>
                        Edit {modalType === 'contact' ? 'Contact Info' : modalType === 'bio' ? 'Bio' : 'Categories'}
                    </Typography>
                    <Divider sx={{ mb: 2 }} />
                    {modalType === 'contact' && (
                        <>
                            <TextField fullWidth label="Email" name="email" value={formValues.email} onChange={handleInputChange} sx={{ mb: 2 }} />
                            <TextField fullWidth label="First Name" name="firstName" value={formValues.firstName} onChange={handleInputChange} sx={{ mb: 2 }} />
                            <TextField fullWidth label="Last Name" name="lastName" value={formValues.lastName} onChange={handleInputChange} sx={{ mb: 2 }} />
                            <TextField fullWidth label="Birth Date" name="birthDate" type="date" value={formValues.birthDate} onChange={handleInputChange} sx={{ mb: 2 }} />
                            <TextField
                                select
                                fullWidth
                                label="Gender"
                                name="gender"
                                value={formValues.gender}
                                onChange={handleInputChange}
                                sx={{ mb: 2 }}
                            >
                                {['Male', 'Female', 'Other'].map((option) => (
                                    <MenuItem key={option} value={option}>
                                        {option}
                                    </MenuItem>
                                ))}
                            </TextField>
                            <Box sx={{ mb: 2 }}>
                                <Typography variant="subtitle2" gutterBottom>Location</Typography>
                                <BusinessLocationAutocomplete
                                        value={formValues.businessLocation ? formValues.businessLocation : formValues.serviceAreaAddress}
                                        onChange={(val) => {
                                            setFormValues((prev) => {
                                                const updated = { ...prev, businessLocation: val };
                                                return updated;
                                              });
                                        }}
                                        setFormValues = {setFormValues}
                                        />
                            </Box>
                        </>
                    )}
                    {modalType === 'bio' && (
                        <TextareaAutosize
                            minRows={4}
                            style={{ width: '100%', padding: '8px', fontSize: '16px' }}
                            name="bio"
                            value={formValues.bio}
                            onChange={handleTextareaChange}
                        />
                    )}
                    {modalType === 'categories' && (
                        <FormControl fullWidth sx={{ mb: 2 }}>
                            <InputLabel id="categories-label">Categories</InputLabel>
                            <Select
                                labelId="categories-label"
                                multiple
                                value={formValues.categories}
                                onChange={handleCategoriesChange as any}
                                renderValue={(selected) => (
                                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                        {(selected as string[]).map((value) => (
                                            <Box key={value} sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>

                                                <Typography variant="body2">{value}</Typography>
                                            </Box>
                                        ))}
                                    </Box>
                                )}
                            >
                                {rootCategories.map((category) => (
                                    <MenuItem key={category} value={category}>
                                        <WorkIcon fontSize="small" sx={{ mr: 1 }} />
                                        {category}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    )}
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSubmit}>
                        {props.isUserLoading ? (
                            <CircularProgress
                                size={24}
                                style={{
                                    color: "white",
                                    position: "absolute",
                                }}
                            />
                        ) : (
                            "Save"
                        )}
                    </Button>
                </Box>
            </Modal>
            <Modal open={isWithdrawModalOpen} onClose={() => setWithdrawModalOpen(false)}>
                <Box
                    sx={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: 400,
                    bgcolor: "background.paper",
                    borderRadius: 2,
                    boxShadow: 24,
                    p: 4,
                    }}
                >
                    <Typography variant="h6" gutterBottom>
                    Withdraw Balance
                    </Typography>

                    <TextField
                    fullWidth
                    label="Amount"
                    value={withdrawAmount}
                    inputProps={{
                        inputMode: 'decimal',
                        pattern: '^[0-9]*[.,]?[0-9]{0,2}$',
                    }}
                    onChange={(e) => {
                        const input = e.target.value;

                        // Only allow numbers and decimal point
                        if (!/^\d*\.?\d*$/.test(input)) return;

                        const value = parseFloat(input);
                        const max = props.userDetails?.balance ?? 0;

                        setWithdrawAmount(input);

                        if (!input || isNaN(value)) {
                        setWithdrawError('Amount is required');
                        } else if (value <= 0) {
                        setWithdrawError('Amount must be greater than 0');
                        } else if (value > max) {
                        setWithdrawError(`Maximum withdrawable amount is ${max.toFixed(2)} GBP`);
                        } else {
                        setWithdrawError('');
                        }
                    }}
                    error={!!withdrawError}
                    helperText={withdrawError}
                    sx={{
                        mt: 2,
                        mb: 3,
                        '& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button': {
                        WebkitAppearance: 'none',
                        margin: 0,
                        },
                        '& input[type=number]': {
                        MozAppearance: 'textfield',
                        },
                    }}
                    />

                    <Box display="flex" justifyContent="flex-end" gap={2}>
                    <Button onClick={() => setWithdrawModalOpen(false)} variant="outlined">
                        Cancel
                    </Button>
                    <Button
                        variant="contained"
                        onClick={handleConfirmWithdraw}
                        disabled={!withdrawAmount || !!withdrawError}
                        sx={{
                        background: 'linear-gradient(to right, #232526, #414345)',
                        color: 'white',
                        fontWeight: 600,
                        '&:hover': {
                            background: 'linear-gradient(to right, #1f1f1f, #373737)',
                        },
                        '&:disabled': {
                            backgroundColor: '#e0e0e0',
                            color: '#9e9e9e',
                            cursor: 'not-allowed',
                        },
                        }}
                    >
                        Confirm Withdrawal
                    </Button>
                    </Box>
                </Box>
                </Modal>
        </>
    );
};

const mapStateToProps = (state: HandymanAppState): StateFromProps => {
    return {
        isCategoriesLoading: state.category.isLoading,
        userCategories: state.category.userCategories,
        authData: state.user.authData,
        isDetailsUpdated: state.user.isDetailsUpdated,
        userDetails: state.user.userDetails,
        currentUser: state.user.currentUserDetails,
        isUserLoading: state.user.isLoading,
    };
};

export default connect<
    StateFromProps,
    DispatchFromProps,
    any,
    HandymanAppState
>(mapStateToProps, {
    getUserCategories,
    updateUserDetails,
    getUserDetails,
})(UserDetails);

